const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.NotificationServiceSimpleClient =
  function NotificationServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.pullNotifications = this.pullNotifications.bind(this);
    this.markNotificationsAsRead = this.markNotificationsAsRead.bind(this);
  };
const methodInfo_NotificationService_PullNotifications =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.NotificationService/PullNotifications",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullNotificationsRequest,
    imports.stronachgroup.first.racehorse360.PullNotificationsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullNotificationsResponse.decode
  );
module.exports.NotificationServiceSimpleClient.prototype.pullNotifications =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullNotificationsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.NotificationService/PullNotifications",
      message,
      metadata || {},
      methodInfo_NotificationService_PullNotifications
    );
  };
const methodInfo_NotificationService_MarkNotificationsAsRead =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.NotificationService/MarkNotificationsAsRead",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest,
    imports.stronachgroup.first.racehorse360.EmptyResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.EmptyResponse.decode
  );
module.exports.NotificationServiceSimpleClient.prototype.markNotificationsAsRead =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.NotificationService/MarkNotificationsAsRead",
      message,
      metadata || {},
      methodInfo_NotificationService_MarkNotificationsAsRead
    );
  };
